<div class="reports-main-page position-relative">
  <div class="header-section row">
    <div
      class="col-12 d-flex date-section justify-content-between align-items-center"
    >
      <div class="name-text">
        <h5>Client Report</h5>
      </div>
      <form autocomplete="off" [formGroup]="selectionDateForm">
        <div class="date-area d-flex">
          <div class="start-date">
            <input
              class="form-control date-input"
              id="startDate"
              formControlName="fromDate"
              [owlDateTimeTrigger]="startDate"
              [owlDateTime]="startDate"
              placeholder="From"
              [max]="minDate"
            />
            <owl-date-time [pickerType]="'calendar'" #startDate></owl-date-time>
            <p
              class="errorMessage mb-0 position-absolute"
              [hidden]="
                selectionDateForm?.get('fromDate')?.valid ||
                selectionDateForm?.get('fromDate')?.untouched
              "
            >
              Start Date is required
            </p>
            <p
              class="errorMessage mb-0 position-absolute"
              [hidden]="!selectionDateForm?.errors?.dateRange"
            >
              Start Date Should Not be Greater than End Date
            </p>
          </div>
          <div class="end-date">
            <input
              class="form-control date-input"
              id="endDate"
              formControlName="toDate"
              [owlDateTimeTrigger]="endDate"
              [owlDateTime]="endDate"
              placeholder="To"
              [max]="minDate"
            />
            <owl-date-time [pickerType]="'calendar'" #endDate></owl-date-time>
            <p
              class="errorMessage mb-0 position-absolute"
              [hidden]="
                selectionDateForm?.get('toDate')?.valid ||
                selectionDateForm?.get('toDate')?.untouched
              "
            >
              End Date is required
            </p>
          </div>
        </div>
      </form>
      <div>
        <div>
          <button class="btn btn-primary btn-sm" (click)="getRangeData()">
            Search
          </button>
        </div>
      </div>
    </div>
    <div class="counts d-flex col-12 mt-2">
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{ totalSalesData.totalOrders ? totalSalesData.totalOrders : 0 }}
        </p>
        <p class="box-names">Total Orders</p>
      </div>
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{
            totalSalesData.activeCustomers ? totalSalesData.activeCustomers : 0
          }}
        </p>
        <p class="box-names">Active Customer</p>
      </div>
      <div class="col-4 box-size">
        <p class="numbers-size">
          {{ totalSalesData.averageOrderAmount | customCurrency }}
        </p>
        <p class="box-names">Avg. Orders Ticket Size</p>
      </div>
    </div>
  </div>

  <div class="total-sales-section row">
    <div class="text-total-sales">
      <h5>Total Sales</h5>
    </div>
    <canvas id="totalSalesChart">{{ totalSalesChart }}</canvas>
  </div>

  <div class="top-20-section row">
    <div
      class="text-top-20 col-12 d-flex justify-content-between align-items-center"
    >
      <div class="name-top-20-text">
        <h5>Top 20 Items</h5>
      </div>
      <div class="drop-down">
        <mat-select
          class="form-control w-100"
          [disableOptionCentering]="true"
          placeholder="Select Range"
          [formControl]="dateRangeControl"
          [compareWith]="compareFn"
          (selectionChange)="getData($event)"
        >
          <mat-option *ngFor="let type of selectionList" [value]="type?.value">
            {{ type?.name }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <canvas id="top20Chart" >{{ chart }}</canvas>
  </div>

  <!-- <div class="four-chart-bars row">
    <div class="d-flex col-12 p-0">
      <div class="four-chart-data col-6">
        <div class="text-sales-bases">
          <h5>Sales Based Order Received</h5>
        </div>
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="salesBasedOrderReceivedLabels"
          [options]="salesBasedOrderReceivedChartOptions"
          [colors]="barChartColors"
          [legend]="barChartLegend"
          [chartType]="salesBasedOrderReceivedChartType"
        >
          ></canvas
        >
      </div>
      <div class="four-chart-data col-6">
        <div class="text-sales-bases">
          <h5>Client Based Order Received</h5>
        </div>
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="clientBasedOrderReceivedLabels"
          [options]="clientBasedOrderReceivedChartOptions"
          [colors]="barChartColors"
          [legend]="barChartLegend"
          [chartType]="clientBasedOrderReceivedChartType"
        >
          ></canvas
        >
      </div>
    </div>
    <div class="d-flex col-12 p-0">
      <div class="four-chart-data col-6">
        <div class="text-sales-bases">
          <h5>Avg. Order Size Report</h5>
        </div>
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="avgOrderSizeLabels"
          [options]="avgOrderSizeChartOptions"
          [colors]="barChartColors"
          [legend]="barChartLegend"
          [chartType]="avgOrderSizeChartType"
        >
          ></canvas
        >
      </div>
      <div class="four-chart-data col-6">
        <div class="text-sales-bases">
          <h5>Sold Most By Area</h5>
        </div>
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="soldMostByAreaLabels"
          [options]="soldMostByAreaChartOptions"
          [colors]="barChartColors"
          [legend]="barChartLegend"
          [chartType]="soldMostByAreaChartType"
        >
          ></canvas
        >
      </div>
    </div>
  </div>

  <div class="sales-trends-section row">
    <div class="text-sales-trends">
      <h5>Sales Trends</h5>
    </div>
    <canvas
      baseChart
      [data]="salesTrendsPieChartData"
      [labels]="pieChartLabels"
      [colors]="salesTrendsPieChartColors"
      [chartType]="salesTrendsbarChartType"
    >
      ></canvas
    >
  </div> -->
</div>

<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
